import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Modal, Dropdown } from 'react-bootstrap'
import Select from 'react-select'

import FilterSearch from 'pages/parts/FilterSearch'
import FilterPagination from 'pages/parts/FilterPagination'

import { returnSign } from "helpers/helpers";
import { httpOk, GET, POST, PUT } from 'helpers/api'

function Index() {
	const { t } = useTranslation()

	const reduxAccount = useSelector(state => state.account)

	// const hotkeys = [
	// 	{ 'id': 'F1', 'name': 'F1' },
	// 	{ 'id': 'F2', 'name': 'F2' },
	// 	{ 'id': 'F3', 'name': 'F3' },
	// 	{ 'id': 'F4', 'name': 'F4' },
	// 	{ 'id': 'F5', 'name': 'F5' },
	// 	{ 'id': 'F6', 'name': 'F6' },
	// 	{ 'id': 'F7', 'name': 'F7' },
	// 	{ 'id': 'F8', 'name': 'F8' },
	// 	{ 'id': 'F9', 'name': 'F9' },
	// 	{ 'id': 'F10', 'name': 'F10' },
	// ]
	const [ptc, setPTC] = useState([])
	const [selectedItem, setSelectedItem] = useState({})
	const [showModal, setShowModal] = useState(false)
	const [filterDataExist, setFilterDataExist] = useState(false)
	const [filterData, setFilterData] = useState({
		pos_id: reduxAccount.pos_id,
		search: '',
	})
	const [pagination, setPagination] = useState({
		url: '/payment-types',
		response: null
	})
	const [data, setData] = useState([])

	async function searchWithFilter() {
		var filterUrl = "/payment-types"
		var urlParams = ""
		checkFilter()

		if (filterData.pos_id)
			urlParams += returnSign(urlParams) + 'pos_id=' + filterData.pos_id
		if (filterData.search)
			urlParams += returnSign(urlParams) + 'search=' + filterData.search
		if (filterData.page)
			urlParams += returnSign(urlParams) + 'page=' + filterData.page
		if (filterData.size)
			urlParams += returnSign(urlParams) + 'size=' + filterData.size

		if (`/payment-types${urlParams}` !== filterUrl)
			setFilterDataExist(true)

		filterUrl = filterUrl + urlParams

		const response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) {
			setData(response.data)
			setPagination({ ...pagination, 'url': filterUrl, 'response': response.data })
		}
	}

	function resetFilter() {
		setFilterData({
			pos_id: reduxAccount.pos_id,
			search: '',
		})
		setFilterDataExist(false)
		searchWithFilter()
	}

	function checkFilter() {
		if (
			filterData.pos_id === null &&
			filterData.search === ''
		) {
			setFilterDataExist(false)
		}
	}

	async function paginate(page, size) {
		setFilterData({ ...filterData, 'page': page, 'size': size })
	}

	async function createUpdate() {
		var response;
		if (selectedItem.payment_type_id) {
			response = await PUT('/payment-types', selectedItem, { loader: true })
		} else {
			response = await POST('/payment-types', selectedItem, { loader: true })
		}

		if (httpOk(response)) {
			searchWithFilter()
			setShowModal(false)
		}
	}

	async function toggleModal(bool = false, item = { 'show_in_cashbox': true }) {
		if (bool) {
			var itemCopy = { ...item }
			setSelectedItem(itemCopy)
			setShowModal(bool)
			return
		}

		setSelectedItem({})
		setShowModal(bool)
	}

	async function getPTC() {
		const response = await GET('/helper/payment-types-categories')
		if (httpOk(response)) setPTC(response.data)
	}

	// async function getPTI() {
	// 	const response = await GET('/helper/payment-types-integrations')
	// 	if (httpOk(response)) setPTI(response.data)
	// }

	useEffect(() => {
		getPTC()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		searchWithFilter()
	}, [filterData.search, filterData.page, filterData.size]) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">
					{t('payment_types')}
				</h4>
				<div className="d-flex">
					<button className="btn-rounded btn btn-primary"
						onClick={() => toggleModal(true)}>
						{t('create')}
					</button>
				</div>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="d-flex flex-wrap mb-3">
						<div className="d-flex flex-wrap gap-2">
							<div>
								<FilterSearch
									filterData={filterData}
									setFilterData={setFilterData}>
								</FilterSearch>
							</div>
						</div>
					</div>

					{filterDataExist &&
						<div className="filter-block">
							<div className="filter">
								<strong>{t('filter')}</strong>
								<br />
								{filterData.search &&
									<span className="me-2">
										<b>{t('search')}: </b>
										<span>{filterData.search}</span>
									</span>
								}
							</div>
							<div className="vertical-center">
								<button className="btn btn-outline-dark text-uppercase" onClick={resetFilter}>{t('reset')}</button>
							</div>
						</div>
					}

					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '20%' }}>{t('name2')}</th>
									<th style={{ 'width': '40%' }}>{t('type')}</th>
									<th style={{ 'width': '20%' }} className="text-center">{t('usd')}</th>
									{/* <th style={{ 'width': '15%' }} className="td-ellipsis text-center"
										title={t('exact_amount')}>
										{t('exact_amount')}
									</th>
									<th style={{ 'width': '15%' }} className="td-ellipsis text-center"
										title={t('hotkeys')}>
										{t('hotkeys')}
									</th> */}
									<th style={{ 'width': '20%' }} className="td-ellipsis text-center"
										title={t('show_in_cashbox')}>
										{t('show_in_cashbox')}
									</th>
									<th style={{ 'minWidth': '33px' }}></th>
								</tr>
							</thead>
							<tbody>
								{data?.map((item, index) => (
									<tr key={index}>
										<td className="text-center">{index + 1}</td>
										<td className="td-ellipsis">{item.name}</td>
										<td className="td-ellipsis">{item.type_category_name}</td>
										<td className="text-center">
											{item.is_usd ?
												<span>{t('yes')}</span>
												:
												<span>{t('no')}</span>
											}
										</td>
										{/* <td className="text-center">
											{item.exact_amount ?
												<span>{t('yes')}</span>
												:
												<span>{t('no')}</span>
											}
										</td>
										<td className="text-center">{item.hotkey}</td> */}
										<td className="text-center">
											{item.show_in_cashbox ?
												<span>{t('yes')}</span>
												:
												<span>{t('no')}</span>
											}
										</td>
										<td>
											<div className="table-dropdown">
												<Dropdown id={`dropdown-${index}`}>
													<Dropdown.Toggle variant="outline-primary">
														<i className="uil uil-ellipsis-v"></i>
													</Dropdown.Toggle>

													<Dropdown.Menu>
														<div className="table-dropdown-item"
															onClick={() => toggleModal(true, item)}>
															<i className="uil-edit-alt"></i>
															{t('edit')}
														</div>
													</Dropdown.Menu>
												</Dropdown>
											</div>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>

					{pagination.response &&
						<FilterPagination
							pagination={pagination}
							paginate={paginate}>
						</FilterPagination>
					}
				</div>
			</div>

			{/* MODAL */}
			<Modal show={showModal} animation={false} size="md"
				centered backdrop="static" onHide={() => toggleModal()}>
				<Modal.Header closeButton>
					<Modal.Title>
						{!selectedItem.id ?
							<>{t('create')}</>
							:
							<>{t('edit')}</>
						}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div>
						<form autoComplete="off">
							<div className="form-group">
								<label>{t('type')}<span className="required-mark">*</span></label>
								<Select
									isDisabled={selectedItem.id}
									options={ptc}
									value={ptc.find(option => option.id === selectedItem.payment_type_category_id)}
									onChange={(option) => setSelectedItem({ ...selectedItem, 'payment_type_category_id': option.id })}
									placeholder=""
									noOptionsMessage={() => t('list_empty')}
									getOptionLabel={(option) => option.name}
									getOptionValue={(option) => option.id}
								/>
							</div>

							<div className="form-group">
								<label>{t('name2')}<span className="required-mark">*</span></label>
								<input type="text" className="form-control" name="name"
									value={selectedItem.name ?? ''}
									onChange={(e) => setSelectedItem({ ...selectedItem, 'name': e.target.value })} />
							</div>
							<div className="form-group">
								<label>{t('name_in_cheque')}<span className="required-mark">*</span></label>
								<input type="text" className="form-control" name="name_in_cheque"
									value={selectedItem.name_in_cheque ?? ''}
									onChange={(e) => setSelectedItem({ ...selectedItem, 'name_in_cheque': e.target.value })} />
							</div>

							<div className="d-flex gap-2">
								{/* <div className="form-group w-100">
									<label>{t('hotkeys')}</label>
									<Select
										isClearable
										options={hotkeys}
										value={hotkeys.find(option => option.id === selectedItem.hotkey)}
										onChange={(option) => setSelectedItem({ ...selectedItem, 'hotkey': option ? option.id : null })}
										placeholder=""
										noOptionsMessage={() => t('list_empty')}
										getOptionLabel={(option) => option.name}
										getOptionValue={(option) => option.id}
									/>
								</div> */}
								<div className="form-group w-100">
									<label>{t('order2')}</label>
									<input type="text" className="form-control" name="order_number"
										value={selectedItem.order_number ?? ''}
										onChange={(e) => setSelectedItem({ ...selectedItem, 'order_number': e.target.value })} />
								</div>
							</div>

							{/* <div className="form-check">
								<input id="fiscal" className="form-check-input" type="checkbox"
									checked={selectedItem?.fiscal ?? false}
									onChange={(e) => setSelectedItem({ ...selectedItem, 'fiscal': e.target.checked })}
								/>
								<label className="form-check-label" htmlFor="fiscal">
									{t('fiscalization')}
								</label>
							</div>

							<div className="form-check">
								<input id="exact_amount" className="form-check-input" type="checkbox"
									checked={selectedItem?.exact_amount ?? false}
									onChange={(e) => setSelectedItem({ ...selectedItem, 'exact_amount': e.target.checked })}
								/>
								<label className="form-check-label" htmlFor="exact_amount">
									{t('exact_amount')}
								</label>
							</div> */}

							<div className="form-check">
								<input id="show_in_cashbox" className="form-check-input" type="checkbox"
									checked={selectedItem?.show_in_cashbox ?? false}
									onChange={(e) => setSelectedItem({ ...selectedItem, 'show_in_cashbox': e.target.checked })}
								/>
								<label className="form-check-label" htmlFor="show_in_cashbox">
									{t('show_in_cashbox')}
								</label>
							</div>

							<div className="form-check">
								<input id="is_usd" className="form-check-input" type="checkbox"
									checked={selectedItem?.is_usd ?? false}
									onChange={(e) => setSelectedItem({ ...selectedItem, 'is_usd': e.target.checked })}
								/>
								<label className="form-check-label" htmlFor="is_usd">
									{t('dollar')}
								</label>
							</div>
						</form>
					</div>

					<div className="d-flex gap-2 w-100 mt-3">
						<button type="button" className="btn btn-outline-warning w-100"
							onClick={() => toggleModal()}>
							{t('cancel')}
						</button>
						<button type="button" className="btn btn-primary w-100"
							onClick={() => createUpdate()}>
							{t('save')}
						</button>
					</div>
				</Modal.Body>
			</Modal>
			{/* MODAL */}
		</>
	)
}

export default Index